// Haptic feedback via the Vibration API.
//
// Support notes (verified against MDN/caniuse as of 2026):
//   - Chrome/Firefox on Android: supported.
//   - iOS Safari: navigator.vibrate does NOT exist (Apple has never shipped
//     the Vibration API, any version) — every call is a silent no-op there.
//     There is no web-exposed alternative on iOS outside <input type=…>
//     switch haptics, so iPhone players simply get no rumble.
//   - Desktop browsers: API may exist but hardware doesn't buzz; harmless.

export type HapticPattern = 'hit' | 'death' | 'tap';

// Milliseconds; arrays alternate vibrate/pause. Kept short — long buzzes
// read as notifications, not game feedback.
const PATTERNS: Record<HapticPattern, number | number[]> = {
  /** UI acknowledgment (button press, build armed). */
  tap: 10,
  /** Took a shell hit / mine chunk. */
  hit: 35,
  /** Tank destroyed. */
  death: [80, 50, 80, 50, 160],
};

/** Fire a short vibration pattern. Graceful no-op wherever the Vibration
 *  API is missing (all of iOS Safari) or blocked (no user gesture yet). */
export function haptic(pattern: HapticPattern): void {
  if (typeof navigator === 'undefined') return;
  if (typeof navigator.vibrate !== 'function') return;
  try {
    navigator.vibrate(PATTERNS[pattern]);
  } catch {
    // Some UAs throw instead of returning false when blocked — ignore.
  }
}
